import '@felix/ui/styles.css';
import { felixCssVariables, felixTheme, PortDataProvider } from '@felix/ui';
import { MantineProvider } from '@mantine/core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { officeApi } from './api.js';
import { BrandingProvider } from './branding.js';
import { DashboardProvider } from './dashboard-data.js';
import { setupI18n } from './i18n.js';
import { SessionProvider } from './session.js';

setupI18n();

const root = document.getElementById('root');
if (!root) throw new Error('#root yok');
createRoot(root).render(
  <StrictMode>
    <MantineProvider
      theme={felixTheme}
      cssVariablesResolver={felixCssVariables}
      defaultColorScheme="light"
    >
      <BrowserRouter>
        <SessionProvider>
          <BrandingProvider>
            <DashboardProvider>
              {/* Liman seçicinin şirket limanları (ADR 0048 §6) */}
              <PortDataProvider companyPorts={officeApi.companyPorts}>
                <App />
              </PortDataProvider>
            </DashboardProvider>
          </BrandingProvider>
        </SessionProvider>
      </BrowserRouter>
    </MantineProvider>
  </StrictMode>,
);
